import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";
import * as Log from "~/app/core/log";
import {UserInfo} from "~/app/core/model/user-info";
import {NavigationService} from "~/app/core/navigation.service";
import {HomePage} from "~/app/pages/home/home.page";

@Component({
    selector: "account",
    templateUrl: "./account.component.html",
    styleUrls: ["./account.component.scss"]
})
export class AccountComponent implements OnInit {

  @Input() homePage: HomePage;
  content: string = 'main';
  userInfo: UserInfo;
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly userProfileService: UserProfileService,
    private readonly navigationService: NavigationService
  ) {
  }

  ngOnInit(): void {
    this.userInfo = this.userProfileService.userInfo;
  }
  onMain() {
    this.content = 'main';
  }

  onInfo() {
    this.content = 'info';
  }

  onNotification() {
    this.content = 'notification';
  }

  onMessage() {
    this.content = 'message';
  }

  onPolicies() {
    this.content = 'policies';
  }

  onContactMerchant() {
    this.content = 'merchants';
  }

  onContactSponsor() {
    this.content = 'sponsors';
  }

  onReport() {
    this.content = 'report';
  }

  onAbout() {
    this.content = 'about';
  }

  onFAQ() {
    this.content = 'faq';
  }

  onInstagram() {
    // TODO
  }

  onFacebook() {
    // TODO
  }

  onLinkedIn() {
    // TODO
  }

  onLogout() {
    this.userProfileService.logout();
    this.userInfo = null;
    this.homePage.go_Home();
  }

  onLogin() {
    this.navigationService.navPageLogin(null, false);
  }

  onResetPassword() {
    // this.userProfileService.resetPassword(this.userInfo.email);
    this.navigationService.navPageForgotPassword(null, false);
  }

  onDisableAccount() {
    this.content = 'disable';
  }

  onUpdateEmail() {
    alert("TODO not implemented");
  }

}
